<div class="modal-header">
  <h4 class="modal-title">{{ 'LK.modal.reportIssue.title' | translate }}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>
<div class="modal-body">
  <form [formGroup]="feedbackForm">
    <div class="mb-3">
      <label for="issueType" class="form-label">{{ 'LK.modal.reportIssue.issueType' | translate }}</label>
      <select class="form-select" id="issueType" formControlName="type">
        <option value="">{{ 'LK.modal.reportIssue.pleaseSelect' | translate }}</option>
        <option value="machine">{{ 'LK.modal.reportIssue.machineError' | translate }}</option>
        <option value="process">{{ 'LK.modal.reportIssue.processError' | translate }}</option>
        <option value="system">{{ 'LK.modal.reportIssue.systemError' | translate }}</option>
        <option value="other">{{ 'LK.modal.reportIssue.other' | translate }}</option>
      </select>
    </div>

    <div class="mb-3">
      <label for="description" class="form-label">{{ 'LK.modal.reportIssue.description' | translate }}</label>
      <textarea class="form-control"
                id="description"
                rows="4"
                formControlName="description"
                [placeholder]="'LK.modal.reportIssue.descriptionPlaceholder' | translate"></textarea>
      <div class="form-text" *ngIf="feedbackForm.get('description')?.errors?.['required'] &&
                     feedbackForm.get('description')?.touched">
        {{ 'LK.modal.reportIssue.descriptionRequired' | translate }}
      </div>
    </div>

    <div class="mb-3">
      <label class="form-label d-block">{{ 'LK.modal.reportIssue.priority' | translate }}</label>
      <div class="btn-group"  formControlName="priority">
        <label  class="btn-outline-secondary">
          <input  type="radio" value="low"> {{ 'LK.modal.reportIssue.priorityLow' | translate }}
        </label>
        <label  class="btn-outline-secondary">
          <input  type="radio" value="medium"> {{ 'LK.modal.reportIssue.priorityMedium' | translate }}
        </label>
        <label  class="btn-outline-secondary">
          <input  type="radio" value="high"> {{ 'LK.modal.reportIssue.priorityHigh' | translate }}
        </label>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button"
          class="btn btn-secondary"
          (click)="close()">{{ 'LK.general.cancel' | translate }}</button>
  <button type="button"
          class="btn btn-primary"
          [disabled]="!feedbackForm.valid"
          (click)="submitFeedback()">
    {{ 'LK.modal.reportIssue.submit' | translate }}
  </button>
</div>
